.list {
  padding-top: 32px;
  padding-bottom: 32px;
}
